import { createdAtSorter } from '@lib/generic.utils'
import ModalLinkTrigger from '@components/ag-grid-helpers/ModalLinkTrigger.vue'
import AttachmentsIndicator from '@components/ag-grid-helpers/AttachmentsIndicator.vue'

export default {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Date/Time',
            field: 'created_at',
            comparator: createdAtSorter,
            cellRenderer: params => this.formatDateTimeForLocale(params.value),
            type: ['textFilterColumn']
          },
          {
            headerName: 'Subject',
            field: 'subject',
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: params.data.id,
                  routeName: 'email-outbox',
                  onClick: emailId => this.$emit('see-subject', emailId),
                  label: params.value
                }
              }
            },
            cellRendererFramework: ModalLinkTrigger,
            type: ['textFilterColumn']
          },
          {
            headerName: 'Sent by',
            field: 'from',
            type: ['textFilterColumn']
          },
          {
            headerName: 'Sent to',
            field: 'to',
            type: ['textFilterColumn']
          },
          {
            headerName: 'File(s)',
            field: 'has_attachments',
            filter: false,
            valueGetter: params => (params?.data?.has_attachments ? 'Yes' : 'No')
          }
        ],

        defaultColDef: {
          floatingFilter: true
        },

        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
